<template>
  <el-form-item
    :label="titlize(label)"
    :rules="metaData.is_required ? requiredField() : []"
  >
    <div class="el-textarea">
      <textarea
        :ref="`input-field-${formIndex}`"
        class="el-textarea__inner"
        rows="4"
        :id="metaData.name"
        :name="metaData.name"
        v-model="parentForm[metaData.name]"
        :required="metaData.is_required"
        @focus="changeColor($event)"
        @blur="resetColor($event)"
        @input="validateInput()"
        :disabled="preview"
      >
      </textarea>
      <div class="el-form-item__error" v-text="errMsg"></div>
    </div>
  </el-form-item>
</template>

<script>
import { titleCase } from "@/lib/utils";

export default {
  name: "Textarea",
  props: {
    label: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    metaData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    colors: {
      type: Object,
      default() {
        return {};
      }
    },
    parentForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    formIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      errMsg: ""
    };
  },

  inject: ["preview"],

  computed: {
    preview() {
      return this.preview;
    }
  },

  methods: {
    validateInput() {
      const inputVal = this.$refs[`input-field-${this.formIndex}`].value;
      if (!this.metaData.is_required && !inputVal.length) {
        return;
      }
      if (this.metaData.is_required && !inputVal.length) {
        this.errMsg = `${this.titlize(this.label)} is required`;
        this.$emit("isValid", false);
        return;
      }
      if (
        this.metaData.field_type &&
        this.metaData.field_type.validation_regex
      ) {
        const regx = new RegExp(this.metaData.field_type.validation_regex, "g");
        const validInput = regx.test(inputVal);
        this.errMsg = !validInput
          ? `${this.titlize(this.label)} is not with in the range`
          : "";
        if (!validInput) {
          this.$emit("isValid", false);
        }
      }
    },

    resetColor(evt) {
      this.validateInput();
      evt.target.style.borderColor = "#dcdfe6";
    },

    changeColor(evt) {
      evt.target.style.borderColor = this.colors.secondary;
    },

    titlize(option) {
      return titleCase(option);
    }
  }
};
</script>

<style lang="scss" scoped></style>
